import { useQuery } from "@tanstack/react-query";
import { QUERY_KEYS } from "app/data/common/queryKeys";
import { apiQueryAdapter } from "app/data/apiQueryAdapter";
import { useSelector } from "react-redux";
import { userSelector } from "slices/user/userSlice";

export const useInboundFreightByTerminal = (originCity?: string | null, status?: string | null, manifest?: string | null) => {
  const userState = useSelector(userSelector);

  const { isFetching, isLoading, data, error } =
    useQuery<any[]>({
      queryKey: [QUERY_KEYS.INBOUND_FREIGHT_BY_TERMINAL, originCity, status, manifest],
      queryFn: async () => {
        let params = {};
        if (originCity) {
          params = { originCity };
        }
        if (status) {
          params = { ...params, status };
        }
        if (manifest) {
          params = { ...params, manifest };
        }

        const response = await apiQueryAdapter.query<any[]>(`/linehaul-manifests/terminal/${userState.activeTerminal?.id}`,
          "GET",
          { params }
        );

        return response.data;
      },
    })
  return { isFetching, isLoading, data, error };
}